import * as React from 'react'

import { classList } from 'react-classlist-helper'

import ToggleControls from './ToggleControls'

interface AppToggleProps {
  isAvailable: boolean
  label: string
  isEnabled: boolean
  onToggle: () => void
  icon?: JSX.Element
  shouldRenderCheckbox?: boolean
  isChecked?: boolean
  onCheckboxToggle?: () => void
  isDisabledToggle?: boolean
  isNested?: boolean
}

const AppToggle: React.FC<AppToggleProps> = ({
  isAvailable,
  label,
  isEnabled,
  onToggle,
  icon,
  shouldRenderCheckbox,
  isChecked,
  onCheckboxToggle,
  isDisabledToggle,
  isNested,
}) => {
  if (!isAvailable) return null

  return (
    <div className="tw:flex tw:h-8 tw:items-center tw:gap-2">
      <div
        className={classList({
          'tw:flex tw:min-w-0 tw:flex-1 tw:items-center tw:gap-2': true,
          'tw:pl-6': !!isNested,
        })}
      >
        {icon}
        <span className="tw:truncate tw:text-app-dense-medium tw:text-foreground">
          {label}
        </span>
      </div>
      <ToggleControls
        isEnabled={isEnabled}
        onToggle={onToggle}
        shouldRenderCheckbox={shouldRenderCheckbox}
        isChecked={isChecked}
        onCheckboxToggle={onCheckboxToggle}
        isDisabledToggle={isDisabledToggle}
      />
    </div>
  )
}

export default AppToggle
